import '@progress/kendo-ui/js/kendo.grid';
import '@progress/kendo-ui/js/kendo.dataviz.chart';
import '@progress/kendo-ui/js/kendo.gantt';
import '@progress/kendo-ui/js/kendo.menu';
import '@progress/kendo-ui/js/kendo.autocomplete';
import '@progress/kendo-ui/js/kendo.list';
import '@progress/kendo-ui/js/kendo.columnmenu';
import '@progress/kendo-ui/js/kendo.filtermenu';
import '@progress/kendo-ui/js/kendo.filtercell';
import '@progress/kendo-ui/js/kendo.dropdownlist';
import '@progress/kendo-ui/js/kendo.numerictextbox';
import '@progress/kendo-ui/js/kendo.resizable';
import '@progress/kendo-ui/js/kendo.selectable';
import '@progress/kendo-ui/js/kendo.calendar';
import '@progress/kendo-ui/js/kendo.popup';
import '@progress/kendo-ui/js/kendo.datepicker';
import '@progress/kendo-ui/js/kendo.binder';

// Kendo Excel
import '@progress/kendo-ui/js/kendo.ooxml';
import '@progress/kendo-ui/js/kendo.excel';

// Kendo PDF
import '@progress/kendo-ui/js/kendo.color';
import '@progress/kendo-ui/js/kendo.drawing';
import '@progress/kendo-ui/js/kendo.popup';
import '@progress/kendo-ui/js/kendo.pdf';
import '@progress/kendo-ui/js/kendo.progressbar';

// Kendo Styles
import '@progress/kendo-theme-default/dist/all.css';
import '@/assets/styles/kendo.scss';

// Kendo Installers
import { ChartInstaller } from '@progress/kendo-charts-vue-wrapper';
import { DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper';
import { Editor } from '@progress/kendo-editor-vue-wrapper';
import { EditorTool } from '@progress/kendo-editor-vue-wrapper';
import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper';
import { GanttInstaller } from '@progress/kendo-gantt-vue-wrapper';
import { GridInstaller } from '@progress/kendo-grid-vue-wrapper';
import { Grid } from '@progress/kendo-vue-grid';


export default {
        install(Vue) {
        Vue.use(ChartInstaller);
        Vue.use(DataSourceInstaller);
        Vue.use(EditorInstaller);
        Vue.use(GanttInstaller);
        Vue.use(GridInstaller);
        Vue.component('kendo-grid-native', Grid);
	}
};
